import React from 'react'
import { useSelector } from 'react-redux'
import './dashboard.scss'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const OffersChart = ({className, barThickness}) => {
  const offerStats = useSelector((s) => s?.adminReducer?.dashboardOfferStats);

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 5,
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart',
      },
      tooltip: {
        enabled: false
      }
    },
    scales: {
      x: {
        grid: {
          offset: false,
          drawOnChartArea: false,
          color: "#655B96"
        },
        ticks: {
          color: "rgba(148, 148, 148, 1)"
        },
        border: {
          color: "rgba(148, 148, 148, 1)"
        }
      },
      y: {
        grid: {
          drawOnChartArea: false,
          color: "#655B96",
          fontSize: "11px",
        },
        ticks: {
          color: "rgba(148, 148, 148, 1)",
          fontSize: "11px",
          stepSize: 20
        },
        border: {
          color: "rgba(148, 148, 148, 1)"
        }
      }
    }
  };
  
  const labels = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  // Try to derive monthly counts from various possible response shapes
  const deriveMonthlyCounts = () => {
    const stats = offerStats || {};
    // Case 1: { monthly: { jan: n, feb: n, ... } } or { byMonth: {...} }
    const monthMap = stats.monthly || stats.byMonth || stats.perMonth || stats.months || stats.monthlyOffers || stats.monthlyBreakdown;
    if (monthMap && typeof monthMap === 'object') {
      const keys = Object.keys(monthMap);
      if (keys.length) {
        // Normalize both lower-case (jan) and capitalized (January)
        const lower = Object.fromEntries(Object.entries(monthMap).map(([k,v]) => [String(k).toLowerCase(), v]));
        const get = (k) => Number(lower[k]) || 0;
        return [
          get('jan') || get('january'),
          get('feb') || get('february'),
          get('mar') || get('march'),
          get('apr') || get('april'),
          get('may'),
          get('jun') || get('june'),
          get('jul') || get('july'),
          get('aug') || get('august'),
          get('sep') || get('september'),
          get('oct') || get('october'),
          get('nov') || get('november'),
          get('dec') || get('december'),
        ].map((v) => v || 0);
      }
    }
    // Case 2: { monthly: [12 numbers] }
    const monthlyArray = Array.isArray(stats.monthly)
      ? stats.monthly
      : Array.isArray(stats.perMonth)
      ? stats.perMonth
      : Array.isArray(stats.monthlyOffers)
      ? stats.monthlyOffers
      : null;
    if (monthlyArray && monthlyArray.length) {
      const arr = monthlyArray.map((v) => Number(v) || 0);
      if (arr.length === 12) return arr;
      // If backend returns fewer than 12, pad
      return [...arr, ...new Array(12 - arr.length).fill(0)];
    }
    // Fallback: all zeros
    return new Array(12).fill(0);
  };

  const monthlyCounts = deriveMonthlyCounts();

  const data = {
    labels,
    datasets: [
      {
        label: 'New Offers',
        data: monthlyCounts,
        backgroundColor: 'rgba(0, 173, 239, 1)',
        barThickness: barThickness
      }
    ],
  };

  return (
    <div className={className} style={{width: '100%', height: '60%'}}>
      <Bar options={options} data={data} />
    </div>
  )
}

export default OffersChart
